const TravelType = Object.freeze({
  DRIVING: "DRIVING",
  WALKING: "WALKING",
  TRANSIT: "TRANSIT",
  BICYCLING: "BICYCLING",
  DIRECT: "DIRECT"
});
export default TravelType;